import { render, staticRenderFns } from "./RenewalInsurance.vue?vue&type=template&id=ce245cf8&scoped=true&"
import script from "./RenewalInsurance.vue?vue&type=script&lang=js&"
export * from "./RenewalInsurance.vue?vue&type=script&lang=js&"
import style0 from "./RenewalInsurance.vue?vue&type=style&index=0&id=ce245cf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce245cf8",
  null
  
)

export default component.exports